import React from "react";
import { pendingConfirmations } from "./messages";
import PendingTransactionsCommon from "./PendingTransactionsCommon";
import Dialog from "./dialog/Dialog";

function PendingTransactions({
  isOpenPendingTransactionModal,
  setIsOpenPendingTransactionModal,
}) {
  return (
    <Dialog
      isOpenModal={isOpenPendingTransactionModal}
      setIsOpenModal={setIsOpenPendingTransactionModal}
      modalHeader={pendingConfirmations}
      directionToOpen="left"
      handleAction={() => setIsOpenPendingTransactionModal(false)}
    >
      <PendingTransactionsCommon isFromBrowser={false} />
    </Dialog>
  );
}

export default PendingTransactions;
